import { cn } from "@d12labs/utils";
import type * as React from "react";

/**
 * KPI stat tile — eyebrow label, large tabular value, optional delta (green/red
 * by sign) and a muted sub-line. Lives in dashboard grids (Home, FitStreak,
 * Meeting Perf, AI usage). Same surface-1 card body as the rest of the system.
 */
export function KPI({
	label,
	value,
	delta,
	sub,
	accent,
	className,
}: {
	label: React.ReactNode;
	value: React.ReactNode;
	/** e.g. "+3" / "-1"; colored by leading sign. */
	delta?: string;
	sub?: React.ReactNode;
	/** Override the value color (e.g. "text-warning", "text-primary-hover"). */
	accent?: string;
	className?: string;
}) {
	return (
		<div
			data-slot="kpi"
			className={cn(
				"flex flex-col gap-1.5 rounded-lg border border-hairline bg-surface-1 p-4",
				className,
			)}
		>
			<span className="text-eyebrow uppercase text-ink-tertiary">{label}</span>
			<div className="flex items-baseline gap-2">
				<span className={cn("display-md tabular-nums", accent ?? "text-foreground")}>{value}</span>
				{delta ? (
					<span
						className={cn(
							"text-meta font-medium",
							delta.startsWith("-") ? "text-destructive" : "text-semantic-success",
						)}
					>
						{delta}
					</span>
				) : null}
			</div>
			{sub ? <span className="text-meta text-ink-subtle">{sub}</span> : null}
		</div>
	);
}
